<sirius-grid [ngClass]="{ 'sir-text-only': !image }">
    <div class="sir-border-top"></div>
    <div class="sir-text">
        <blockquote
            [class.sir-text-style-quote-s-default]="!!image"
            [class.sir-text-style-quote-m-default]="!image"
            [innerHtml]="textHtml"></blockquote>
        @if (authorHtml) {
            <cite class="sir-cite sir-text-style-paragraph-l-default" [innerHtml]="authorHtml"></cite>
        }
    </div>
    @if (image) {
        <div class="sir-media">
            <sirius-image-item [image]="image" [imageData]="imageData" [autocrop]="false" [roundedCorners]="true">
            </sirius-image-item>
        </div>
    }
    <div class="sir-border-bottom"></div>
</sirius-grid>
